export default __webpack_public_path__ + "static/room-of-mirrors-8aff0f22ffe76ecd0a7685798a1153eb.png";